import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { ApiService } from '../../../../services/api.service';

@Component({
  selector: 'app-elimina-ondemand-backoffice',
  templateUrl: './elimina-ondemand-backoffice.component.html',
  styleUrls: ['./elimina-ondemand-backoffice.component.css']
})
export class EliminaOndemandBackofficeComponent {

  constructor(private apiService: ApiService) { }

  loading: boolean = false;

  readonly #modal = inject(NzModalRef);
  readonly nzModalData = inject(NZ_MODAL_DATA);

  onElimina() {
    this.loading = true;

    // Elimino l'ondemand
    this.apiService.deleteOndemand(this.nzModalData.id_ondemand!).subscribe({
      next: (data) => this.apiService.setOndemands(),
      error: (err) => {
        this.loading = false;
        this.apiService.error(err.error.message);
      },
      complete: () => {
        this.loading = false;
        this.apiService.setOndemands();
        this.#modal.destroy();
      }
    })

  }

  onClose() {
    this.#modal.destroy(false);
  }

}